module.exports = __webpack_public_path__ + "img/mitzi_mobile.51f34cf.png";